/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react'
// material
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
import { url } from 'utils/urls'
import PreviewConfig from '../../previewconfig/previewconfig'
// styles
import injectSheet from 'react-jss'
import styles from './stickyheader_styles'
import Space from 'material/space/space'
import { InlineMessage } from '@insticator/insticator-ui/dist/material'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : STICKY HEADER ~~~~~~~~~~ ========== */
const StickyHeader = injectSheet(styles)((props) => {
  const { useStickyHeader, onChange } = props

  return (
    <SectionGroupV2 
      klass={`stickyheader ${props.classes.stickyheader}`}
      title={'Sticky Header'}
    >
      <Space direction={'column'} gap={16}>
        <InlineMessage 
            key={'note'}
            display={true}
            name={'reportnote'}
            variant={'neutral'}
            icon={'exclamation-triangle'}
            title={null}
            message={`This will only be reflected when header is enabled in General > Header Title`}
            close={false}
            handleClose={null} 
          />
        <ConfigToggle 
          title={'Enable header to remain fixed at the top of the page'}
          description={'Allows users to easily access their notifications and profile at any point without needing to scroll back up to the top of the unit.'}
          checked={useStickyHeader}
          onChange={val => onChange('useStickyHeader', val)}
        />
      </Space>
      <PreviewConfig>
        <img src={`${url.image}/2.0/sticky-header-preview-${useStickyHeader ? 'sticky' : 'fixed'}.png`} alt=""  />
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default StickyHeader;